import { Injectable } from '@angular/core';
import { iEntrada } from './entrada/entrada.interface';

interface iStoreState {
  entradas: Array<object>;
  fechasCargadas: Array<string>;
  entradaPadre: any
}

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public storeState : iStoreState = { 
    entradas: [],
    fechasCargadas: [],
    entradaPadre: false
  };
  
  setEntradas(item: any) {
    this.storeState.entradas = item;
  }

  getEntradas() {
    return this.storeState.entradas;
  }
  
  setFechas(item: string) {
    this.storeState.fechasCargadas.push(item);
  }

  getFechas() {
    return this.storeState.fechasCargadas;
  }

  setEntradaPadre(oEntrada: any) {
    this.storeState.entradaPadre = oEntrada;
  }

  getEntradaPadre() {
    return this.storeState.entradaPadre;
  }

  resetStore() {
    this.storeState = {
      entradas: [],
      fechasCargadas: [],
      entradaPadre: false
    };
  }
}
